import React from "react";
import "../assets/scss/3-components/CustomCursorPagination.scss";



// Material Design icons matching react-data-table-component
const FirstPageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
    <path fill="none" d="M24 24H0V0h24v24z" />
  </svg>
);

const LastPageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
    <path fill="none" d="M0 0h24v24H0V0z" />
  </svg>
);

const LeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

const RightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

const DropdownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M7 10l5 5 5-5z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);


export const CustomCursorPagination = ({
                                        rowsPerPage,
                                        rowCount,
                                        currentPage,
                                        onChangePage,
                                        onChangeRowsPerPage,
                                        store,
                                        currentDataLength
                                      }) => {
  const isCursorMode = store?.isCursorMode ? store.isCursorMode() : false;

  const totalPages = Math.ceil(rowCount / rowsPerPage);
  const start = (currentPage - 1) * rowsPerPage + 1;
  const end = currentDataLength !== undefined
    ? start + currentDataLength - 1
    : currentPage * rowsPerPage;

  const ES_WINDOW_LIMIT = store.esWindowLimit;

  const lastOffsetPage = Math.min(
    Math.floor(ES_WINDOW_LIMIT / rowsPerPage),
    Math.ceil(rowCount / rowsPerPage)
  );

  const rangeText = `${start}–${end} of ${ES_WINDOW_LIMIT}+`;

  return (
    <div className="custom-pagination">
      {/* Rows per page */}
      <div className="custom-pagination__rows">
        <span className="custom-pagination__label">Rows per page:</span>
        <div className="custom-pagination__select-wrapper">
          <select
            value={rowsPerPage}
            onChange={(e) => {
              const newRowsPerPage = Number(e.target.value);
              const currentOffset = (currentPage - 1) * rowsPerPage;
              const expectedNewPage = Math.floor(currentOffset / newRowsPerPage) + 1;
              onChangeRowsPerPage(newRowsPerPage, expectedNewPage);
              onChangePage(expectedNewPage);
            }}
            className="custom-pagination__select"
            aria-label="Rows per page:"
          >
            {[10, 25, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <div className="custom-pagination__dropdown-icon">
            <DropdownIcon />
          </div>
        </div>
      </div>

      {/* Range text */}
      <span className="custom-pagination__range">{rangeText}</span>

      {/* Navigation */}
      <div className="custom-pagination__nav">
        {/* First */}
        <button  className="custom-pagination__button"
                 disabled={currentPage === 1}
                 onClick={() => {
                   if (isCursorMode) {
                     store.resetPaginationState();
                     onChangePage(1);   // normal offset fetch
                   } else {
                     onChangePage(1);
                   }
                 }}
        >
          <FirstPageIcon />
        </button>

        {/* Prev */}
        <button
          className="custom-pagination__button"
          disabled={isCursorMode || currentPage === 1}
          onClick={() => onChangePage(currentPage - 1)}
        >
          <LeftIcon />
        </button>

        {/* Next */}
        <button
          className="custom-pagination__button"
          disabled={currentPage >= totalPages || (isCursorMode && currentDataLength < rowsPerPage)}
          onClick={() => onChangePage(currentPage + 1)}
        >
          <RightIcon />
        </button>

        {/* Last */}
        <button
          className="custom-pagination__button"
          disabled={isCursorMode || currentPage >= lastOffsetPage}
          onClick={() => onChangePage(lastOffsetPage)}
        >
          <LastPageIcon />
        </button>
      </div>
    </div>
  );
};

export default CustomCursorPagination;
